/**
 * 使用比例取得對應陣列長度的 index
 * @param ratio 介於 0 ~ 1 之間的數值
 * @param totalLength 陣列長度
 * @returns 陣列 index
 */
export const getRatioIndex = (ratio: number, totalLength: number) => {
  return Math.min(Math.floor(ratio * totalLength), totalLength - 1)
}
